/** <scapescene-start-screen>: the shared workshop start screen (name +
 * join / create a group + the groups already joined on this device) from
 * @starling-cloud/sturnia-workshop, wrapped as a custom element so the
 * router can mount it like every other screen. Observed attribute
 * "join-code" is set by app.ts for #/join?code=X deep links. */

import { renderStart, type Rendered } from "@starling-cloud/sturnia-workshop";

import { store } from "../store";
import { t } from "../lib/i18n";

class WorkshopStartScreen extends HTMLElement {
  static observedAttributes = ["join-code"];

  #rendered: Rendered | null = null;

  connectedCallback(): void {
    this.#mount();
  }

  disconnectedCallback(): void {
    this.#rendered?.destroy();
    this.#rendered = null;
  }

  attributeChangedCallback(name: string, oldValue: string, newValue: string): void {
    if (name === "join-code" && oldValue !== newValue && this.isConnected) {
      // A new deep link while mounted: re-render with the code pre-filled.
      this.#mount();
    }
  }

  #mount(): void {
    this.#rendered?.destroy();
    this.innerHTML = "";
    const screen = document.createElement("div");
    screen.className = "start-screen";
    this.append(screen);
    this.#rendered = renderStart(screen, {
      session: store,
      title: "Starling Storyboard",
      tagline: t("tagline"),
      joinCode: this.getAttribute("join-code") ?? "",
      labels: {
        name: t("ssName"),
        namePlaceholder: t("ssNamePlaceholder"),
        join: t("ssJoin"),
        joinHint: t("ssJoinHint"),
        code: t("ssCode"),
        joinButton: t("ssJoinButton"),
        create: t("ssCreate"),
        createHint: t("ssCreateHint"),
        createButton: t("ssCreateButton"),
        yourGroups: t("ssYourGroups"),
      },
    });
  }
}

if (!customElements.get("scapescene-start-screen")) {
  customElements.define("scapescene-start-screen", WorkshopStartScreen);
}

export {};
